import { frontendURL } from 'dashboard/helper/URLHelper';

const INTERNAL_CHAT_PERMISSIONS = [
  'administrator',
  'agent',
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal-chat'),
    name: 'internal_chat',
    meta: {
      permissions: INTERNAL_CHAT_PERMISSIONS,
    },
    component: () => import('./InternalChatView.vue'),
  },
];
